if (!customElements.get('customer-reviews')) {
  class CustomerReviews extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('[data-reviews-list]');
      this.arrows = this.querySelector('.customer-reviews__arrows');
      this.prevButton = this.querySelector('[data-reviews-prev]');
      this.nextButton = this.querySelector('[data-reviews-next]');
      this.update = this.update.bind(this);
    }

    connectedCallback() {
      if (!this.list) return;

      this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton.addEventListener('click', () => this.scrollByCard(1));
      this.list.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      this.list.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-reviews-toggle]');
        if (toggle) this.toggleReview(toggle);
      });

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.list);
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    update() {
      this.updateToggles();
      this.updateArrows();
    }

    // Only a review that is actually cut off gets a Read more button.
    updateToggles() {
      this.list.querySelectorAll('[data-reviews-toggle]').forEach((toggle) => {
        const body = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!body || body.classList.contains('is-expanded')) return;
        toggle.hidden = body.scrollHeight <= body.clientHeight + 1;
      });
    }

    toggleReview(toggle) {
      const body = document.getElementById(toggle.getAttribute('aria-controls'));
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      body.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', expanded);
      toggle.textContent = expanded ? this.dataset.labelLess : this.dataset.labelMore;
    }

    // Arrows show only when there is something to scroll to.
    updateArrows() {
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      this.arrows.hidden = maxScroll <= 4;
      this.prevButton.disabled = this.list.scrollLeft <= 2;
      this.nextButton.disabled = this.list.scrollLeft >= maxScroll - 2;
    }

    scrollByCard(direction) {
      const card = this.list.querySelector('.customer-reviews__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      this.list.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
    }
  }

  customElements.define('customer-reviews', CustomerReviews);
}
